// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"fb5311d5","95":"acb7834f","375":"c8057d41","452":"40c8f936","453":"3c4e4d28","470":"89bc24e5","608":"fb6631aa","748":"0c90afa1","864":"874297d8"}[chunkId] + ".chunk.js";
};